import React from 'react';
import { Icon } from './icons';
import { DateInput, TimeInput, dayKey } from './pickers';

// Invio programmato: giorno scelto ogni volta (nessuno predefinito), ora proposta alle 9:00 e modificabile.

export interface When {
  date: string;
  time: string;
}

export const newWhen = (): When => ({ date: '', time: '09:00' });

/** Data e ora locali → istante ISO (null se manca il giorno). */
export function whenToIso(w: When | null): string | null {
  if (!w || !w.date || !/^\d{1,2}:\d{2}$/.test(w.time)) return null;
  const [y, m, d] = w.date.split('-').map(Number);
  const [h, min] = w.time.split(':').map(Number);
  return new Date(y, m - 1, d, h, min).toISOString();
}

export function whenLabel(iso: string): string {
  const d = new Date(iso);
  const day = d.toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' });
  return `${day}, ${d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}`;
}

/** Controlla la scelta: restituisce il messaggio d'errore o null. */
export function whenError(w: When): string | null {
  const iso = whenToIso(w);
  if (!iso) return "Scegli il giorno dell'invio";
  if (new Date(iso).getTime() < Date.now()) return "Il giorno e l'ora scelti sono già passati";
  return null;
}

/** Riga "Invia il … alle …" da mostrare sopra i pulsanti. */
export function SchedulePicker({ value, onChange, onClear }: { value: When; onChange: (w: When) => void; onClear?: () => void }) {
  return (
    <div className="schedule-pick">
      <Icon name="clock" size={16} />
      <span>Invia il</span>
      <div className="schedule-date">
        <DateInput value={value.date} onChange={(date) => onChange({ ...value, date })} allowEmpty placeholder="Scegli il giorno" min={dayKey(new Date())} />
      </div>
      <span>alle</span>
      <div className="schedule-time">
        <TimeInput value={value.time} onChange={(time) => onChange({ ...value, time })} from={0} to={23} step={15} />
      </div>
      {onClear && (
        <button type="button" className="btn icon small ghost" onClick={onClear} title="Invia subito invece">
          <Icon name="x" size={14} />
        </button>
      )}
    </div>
  );
}
